import { Alert, Button, Stack } from '@mui/material';

interface ErrorAlertProps {
  message: string;
  onRetry?: () => void;
}

export function ErrorAlert({ message, onRetry }: ErrorAlertProps) {
  return (
    <Stack spacing={1.5}>
      <Alert severity="error">{message}</Alert>
      {onRetry ? (
        <Button variant="outlined" onClick={onRetry}>
          Retry
        </Button>
      ) : null}
    </Stack>
  );
}
